<template>
  <v-navigation-drawer
    v-model="isOpenModel"
    fixed
    app
    disable-resize-watcher
    width="calc(100% - 32px)"
    style="max-width: 240px; z-index: 2000;"
  >
    <v-img class="ml-4 mt-2" contain position="left" height="64" alt="NOOS" :src="NOOS_LOGO" />
    <v-list dense>
      <template v-for="item in list">
        <v-list-item v-if="!item.isGroup" class="alignItems" color="primary" :key="item.title" :to="item.path">
          <v-list-item-action class="fixedWidth mr-7">
            <v-badge class="pt-1 pl-1" overlap dot left color="red" v-if="item.indicator">
              <v-icon alt="item.title">
                {{ item.icon }}
              </v-icon>
            </v-badge>
            <v-icon size="22" v-else alt="item.title">
              {{ item.icon }}
            </v-icon>
          </v-list-item-action>

          <v-list-item-content class="alignItems">
            <v-list-item-title>
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group v-else
                      v-model="item.subGroupActivated"
                      append-icon=""
                      color="primary"
                      class="alignItems"
                      :group="item.id"
                      :key="item.id"
                      @click.stop="() => redirectOnGroup(item)"
        >
          <template v-slot:activator>
            <v-list-item-action :id="item.id" class="mr-7 fixedWidth">
              <v-badge class="pt-1 pl-1" overlap dot left color="red" v-if="item.indicator">
                <v-icon alt="item.title">
                  {{ item.icon }}
                </v-icon>
              </v-badge>
              <v-icon size="22" v-else alt="item.title">
                {{ item.icon }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-content class="alignItems">
              <v-list-item-title>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list class="list-scroll py-0" v-if="item.isGroup" dense :style="getSubListStyle(item)">
            <v-list-item v-for="subItem in item.subItems"
                         color="primary"
                         :key="subItem.name"
                         :to="{ path: item.path, hash: subItem.id }"
                         link
            >
              <v-list-item-title class="font-weight-light" v-text="subItem.name" />
            </v-list-item>
          </v-list>
        </v-list-group>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
const NOOS_LOGO = require('@/assets/images/logo_noos.png');

const SUB_ITEM_HEIGHT = 2.5;
export default {
  name: 'NavigationDrawer',
  data() {
    return {
      NOOS_LOGO,
      isOpenModel: false,
    };
  },
  props: {
    currentId: {
      type: String,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    this.isOpenModel = this.isOpen;
  },
  watch: {
    isOpen(next) {
      this.isOpenModel = next;
    },
    isOpenModel(next) {
      this.$emit('set-open', next);
    },
  },
  computed: {
    drawer: {
      get() {
        return this.isOpen;
      },
      set(value) {
        this.$emit('drawer-change', value);
      },
    },
    list: {
      get() {
        return (this.items || [])
          .map((item) => ({
            ...item,
            subGroupActivated: item.id === this.currentId,
            isGroup: this.getIsGroup(item),
          }));
      },
    },
  },
  methods: {
    getIsGroup(item) {
      return item.subItems && item.subItems.length;
    },
    getSubListStyle(item) {
      if (item.isGroup) {
        return { 'min-height': `${(Math.min(item.subItems.length, 3) * SUB_ITEM_HEIGHT)}rem` };
      }

      return null;
    },
    redirectOnGroup({ id, path }) {
      if (this.currentId !== id || this.$route.hash) {
        this.$router.push({ path, hash: '' });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.alignItems {
  align-items: center;
}
.fixedWidth {
  width: 30px;
}
.list-scroll {
  max-height: calc(100vh - 366px);
  overflow-y: auto;
}
</style>
